export default "__VITE_ASSET__KQ7czxkK__"